import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import ConversationIcon from "../assets/images/conversation.svg";
import { useTranslation } from "hhn-commons";
import theme from "../theme";

const EmptyMessageWrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0.5;
  background-color: ${theme.palette.grey[50]};
`;

const EmptyMessagePanelView = (): React.JSX.Element => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  return (
    <EmptyMessageWrapper>
      <img src={ConversationIcon} alt="No chat selected" width="120px" />
      <Typography variant="h6" color="black" sx={{ mt: 2 }}>
        {tNs("empty.selectConversation")}
      </Typography>
    </EmptyMessageWrapper>
  );
};
export default EmptyMessagePanelView;
